export enum RolesEnum {
  private_seller = 'PRIVATE_SELLER',
  dealer ='DEALER',
  admin = 'ADMIN'
}
